import type { AxiosError } from "axios";

import type { ThunkActionCreator } from "..";
import { actions } from "./actions";
import cachedJupyterImagesResponse from "./cachedJupyterImagesResponse";

const tempExtraImages = [
  "registry.console.elementai.com/eai.demo/jupyter_with_eai",
];

export const getJupyterImages: ThunkActionCreator =
  () => async (dispatch, getState) => {
    dispatch(actions.getJupyterImages.request());
    const extraIncludedImages = (
      getState().user.user?.feature as
        | { eaiDemoNotebookImage?: boolean }
        | undefined
    )?.eaiDemoNotebookImage
      ? tempExtraImages
      : [];
    try {
      // TODO: actually fetch
      // const responseData: { results: any[] } = await (
      //   await fetch("/jupyter_repositories?page_size=50", {
      //     credentials: "include",
      //     cache: "no-cache",
      //   })
      // ).json();
      const responseData = cachedJupyterImagesResponse;
      const images = responseData.results
        .filter((result) => result.repository_type === "image")
        .map((result) => `${result.namespace}/${result.name}`)
        .filter((name) => /jupyter\/\w+-notebook$/.test(name))
        .concat(extraIncludedImages);
      dispatch(actions.getJupyterImages.success(images));
    } catch (err) {
      console.log(err);
      dispatch(
        actions.getJupyterImages.failure(err as AxiosError<unknown, any>),
      );
    }
  };
